import React, { useState } from 'react';
import { ClickAwayListener } from '@material-ui/core';
import Image from '@/Common/Image';
import './index.scss';

/**
 * 
 * @param {{
 *  options: {
 *      value: any,
 *      label: string,
 *      icon: string,
 *  }[],
 *  selectedOption: {
 *      value: any,
 *      label: string,
 *      icon: string,
 *  },
 *  onSelect: (option: {
 *      value: any,
 *      label: string,
 *      icon: string,
 *  }) => void,
 * }} param 
 */
const DropdownV2 = ({ options, selectedOption, onSelect }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleToggleDropdown = () => {
        setIsOpen(!isOpen);
    }

    const handleCloseDropdown = () => {
        setIsOpen(false);
    }

    if (!options || options.length === 0 || !selectedOption) {
        return <></>;
    }

    return (
        <ClickAwayListener onClickAway={handleCloseDropdown}>
            <div className="dropdown-v2" onClick={handleToggleDropdown}>
                <div className="dropdown-row">
                    {selectedOption.icon ? <Image src={selectedOption.icon} alt={selectedOption.label} /> : <></>}
                    <span>{selectedOption.label}</span>
                    <Image
                        className={`arrow-icon ${isOpen ? "open" : ""}`}
                        src="https://front.videomonster.com/images-7cuytg20/common/v2/arrow-down.svg"
                        alt="arrow"
                    />
                </div>
                {isOpen && (
                    <div className="dropdown-listBox">
                        {options.map((option, index) => (
                            <div
                                key={index}
                                className={`dropdown-listItem ${selectedOption.value === option.value ? "selected" : ""}`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onSelect(option);
                                    handleCloseDropdown();
                                }}
                            >
                                {option.icon ? <Image src={option.icon} alt="" /> : <></>}
                                <span>{option.label}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </ClickAwayListener>
    )
};

export default DropdownV2;